"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const command_1 = require("../type/command");
const applyAddCheckpointSubmissionCommand_1 = require("./applyAddCheckpointSubmissionCommand");
const applyAddSubmissionCommand_1 = require("./applyAddSubmissionCommand");
const applyAddTimeCommand_1 = require("./applyAddTimeCommand");
const applyAssignContent_1 = require("./applyAssignContent");
const applyChangeDueDate_1 = require("./applyChangeDueDate");
const applyChangeReviewerCommand_1 = require("./applyChangeReviewerCommand");
const applyCheckAnswerCommand_1 = require("./applyCheckAnswerCommand");
const applyDeassignContent_1 = require("./applyDeassignContent");
const applyEvaluateCheckpointCommand_1 = require("./applyEvaluateCheckpointCommand");
const applyFlagAssignmentQuestionCommand_1 = require("./applyFlagAssignmentQuestionCommand");
const applyForceComplete_1 = tslib_1.__importDefault(require("./applyForceComplete"));
const applyIncrementAccessCountCommand_1 = require("./applyIncrementAccessCountCommand");
const applyMarkAttendanceILTSessionCommand_1 = require("./applyMarkAttendanceILTSessionCommand");
const applyPeerReviewGivenCommand_1 = require("./applyPeerReviewCommand/applyPeerReviewGivenCommand");
const applyPeerReviewReceivedCommand_1 = require("./applyPeerReviewCommand/applyPeerReviewReceivedCommand");
const applyPerQuestionSubmissionCommand_1 = require("./applyPerQuestionSubmissionCommand");
const applyRegisterILTSessionCommand_1 = require("./applyRegisterILTSessionCommand");
const applyRegisterILTSessionsCommand_1 = require("./applyRegisterILTSessionsCommand");
const applyRemoveTeacherFeedbackCommand_1 = require("./applyRemoveTeacherFeedbackCommand");
const applyRemoveTeacherGradeCommand_1 = require("./applyRemoveTeacherGradeCommand");
const applyResetProgress_1 = require("./applyResetProgress");
const applyResubmitCommand_1 = require("./applyResubmitCommand");
const applySetAssignmentStartTimeCommand_1 = require("./applySetAssignmentStartTimeCommand");
const applySetProgressCommand_1 = require("./applySetProgressCommand");
const applySubscribeForIltUpdatesCommand_1 = require("./applySubscribeForIltUpdatesCommand");
const applySwitchToLatestContentCommand_1 = require("./applySwitchToLatestContentCommand");
const applyTeacherFeedbackCommand_1 = require("./applyTeacherFeedbackCommand");
const applyTeacherGradeCommand_1 = require("./applyTeacherGradeCommand");
const applyUnregisterILTSessionCommand_1 = require("./applyUnregisterILTSessionCommand");
const applyUnregisterILTSessionsCommand_1 = require("./applyUnregisterILTSessionsCommand");
const applyUnsubmitCommand_1 = require("./applyUnsubmitCommand");
const applyUpdateBlockPerformanceCommand_1 = require("./applyUpdateBlockPerformanceCommand");
const applyUpdateContentCommand_1 = require("./applyUpdateContentCommand");
const applyUpdateIltSessionStateCommand_1 = require("./applyUpdateIltSessionStateCommand");
const applyUpdateScormCommand_1 = require("./applyUpdateScormCommand");
function applyCommand(command, user, content, childContents, states, enrolments, stateInteractions) {
    switch (command.type) {
        case command_1.CommandType.ADD_TIME:
            return applyAddTimeCommand_1.applyAddTimeCommand(command, user, content, states);
        case command_1.CommandType.ADD_CHECKPOINT_SUBMISSION:
            return applyAddCheckpointSubmissionCommand_1.applyAddCheckpointSubmissionCommand(command, user, content, states, enrolments);
        case command_1.CommandType.EVALUATE_CHECKPOINT:
            return applyEvaluateCheckpointCommand_1.applyEvaluateCheckpointCommand(command, user, content, states, enrolments, stateInteractions);
        case command_1.CommandType.CHANGE_REVIEWER:
            return applyChangeReviewerCommand_1.applyChangeReviewerCommand(command, user, content, states, enrolments, stateInteractions);
        case command_1.CommandType.PEER_REVIEW:
            return applyPeerReviewGivenCommand_1.applyPeerReviewGivenCommand(command, content, user, states, stateInteractions);
        case command_1.CommandType.PEER_REVIEW_RECEIVED:
            return applyPeerReviewReceivedCommand_1.applyPeerReviewReceivedCommand(command, content, states, stateInteractions);
        case command_1.CommandType.REGISTER_SESSION:
            return applyRegisterILTSessionCommand_1.applyRegisterILTSessionCommand(command, user, states);
        case command_1.CommandType.REGISTER_SESSIONS:
            return applyRegisterILTSessionsCommand_1.applyRegisterILTSessionsCommand(command, user, states);
        case command_1.CommandType.UNREGISTER_SESSION:
            return applyUnregisterILTSessionCommand_1.applyUnregisterILTSessionCommand(command, user, content, states);
        case command_1.CommandType.UNREGISTER_SESSIONS:
            return applyUnregisterILTSessionsCommand_1.applyUnregisterILTSessionsCommand(command, user, states);
        case command_1.CommandType.ASSIGN_CONTENT:
            return applyAssignContent_1.applyAssignContent(command, user, content, childContents, states, enrolments, stateInteractions);
        case command_1.CommandType.DEASSIGN_CONTENT:
            const deAssignPayload = applyDeassignContent_1.applyDeassignContent(command, user, content, childContents, states, enrolments);
            return Object.assign({}, deAssignPayload, { stateInteractions });
        case command_1.CommandType.CHANGE_DUE_DATE:
            const dueDateChangePayload = applyChangeDueDate_1.applyChangeDueDate(command, user, content, childContents, enrolments);
            return Object.assign({}, dueDateChangePayload, { states, stateInteractions });
        case command_1.CommandType.MARK_ATTENDANCE:
            return applyMarkAttendanceILTSessionCommand_1.applyMarkAttendanceILTSessionCommand(command, user, states);
        case command_1.CommandType.UPDATE_ILT_SESSION_STATE:
            return applyUpdateIltSessionStateCommand_1.applyUpdateIltSessionStateCommand(command, user, content, states);
        case command_1.CommandType.ADD_SUBMISSION:
            return applyAddSubmissionCommand_1.applyAddSubmissionCommand(command, user, content, states);
        case command_1.CommandType.PER_QUESTION_SUBMISSION:
            return applyPerQuestionSubmissionCommand_1.applyPerQuestionSubmissionCommand(command, user, content, states);
        case command_1.CommandType.FLAG_ASSIGNMENT_QUESTION:
            return applyFlagAssignmentQuestionCommand_1.applyFlagAssignmentQuestionCommand(command, user, content, states);
        case command_1.CommandType.SET_ASSIGNMENT_START_TIME:
            return applySetAssignmentStartTimeCommand_1.applySetAssignmentStartTimeCommand(command, user, content, states);
        case command_1.CommandType.SET_PROGRESS:
            return applySetProgressCommand_1.applySetProgressCommand(command, user, content, states);
        case command_1.CommandType.INCREMENT_ACCESS_COUNT:
            return applyIncrementAccessCountCommand_1.applyIncrementAccessCountCommand(command, user, content, states);
        case command_1.CommandType.CHECK_ANSWER:
            return applyCheckAnswerCommand_1.applyCheckAnswerCommand(command, states);
        case command_1.CommandType.UPDATE_BLOCK_PERFORMANCE:
            return applyUpdateBlockPerformanceCommand_1.applyUpdateBlockPerformanceCommand(command, user, content, states);
        case command_1.CommandType.UNSUBMIT:
            return applyUnsubmitCommand_1.applyUnsubmitCommand(command, user, content, states);
        case command_1.CommandType.RESUBMIT:
            return applyResubmitCommand_1.applyResubmitCommand(command, user, content, states);
        case command_1.CommandType.RESET_PROGRESS:
            return applyResetProgress_1.applyResetProgress(command, user, content, childContents, states, enrolments, stateInteractions);
        case command_1.CommandType.FORCE_COMPLETE: {
            const forceCompletePayload = applyForceComplete_1.default(command, user, content, childContents, states);
            return {
                enrolments,
                events: forceCompletePayload.events,
                stateInteractions,
                states: forceCompletePayload.states
            };
        }
        case command_1.CommandType.UPDATE_CONTENT:
            return applyUpdateContentCommand_1.applyUpdateContentCommand(command, user, content, childContents, states, enrolments);
        case command_1.CommandType.SWITCH_TO_LATEST_CONTENT:
            return applySwitchToLatestContentCommand_1.applySwitchToLatestContentCommand(command, user, content, childContents, states, enrolments);
        case command_1.CommandType.UPDATE_SCORM:
            return applyUpdateScormCommand_1.applyUpdateScormCommannd(command, user, content, states);
        case command_1.CommandType.TEACHER_FEEDBACK:
            return applyTeacherFeedbackCommand_1.applyTeacherFeedbackCommand(command, user, states, stateInteractions);
        case command_1.CommandType.REMOVE_TEACHER_FEEDBACK:
            return applyRemoveTeacherFeedbackCommand_1.applyRemoveTeacherFeedbackCommand(command, user, states, stateInteractions);
        case command_1.CommandType.TEACHER_GRADE:
            return applyTeacherGradeCommand_1.applyTeacherGradeCommand(command, user, content, states, stateInteractions);
        case command_1.CommandType.REMOVE_TEACHER_GRADE:
            return applyRemoveTeacherGradeCommand_1.applyRemoveTeacherGradeCommand(command, user, content, states, stateInteractions);
        case command_1.CommandType.SUBSCRIBE_FOR_ILT_UPDATES:
            return applySubscribeForIltUpdatesCommand_1.applySubscribeForIltUpdatesCommand(command, user, content, states);
        default:
            console.info('Unknown command type found:', command.type);
            return { events: [], states, stateInteractions, enrolments };
    }
}
exports.applyCommand = applyCommand;
//# sourceMappingURL=index.js.map